/**
 * safe-storage shim — a NO-OP replacement for prod lib/safe-storage.ts.
 *
 * WHY (adversarial-review HIGH #3): synced leaves (use-bilateral-mirror, ClientView)
 * persist session lifecycle flags and check-in answers to window.sessionStorage via
 * safeStorageSet. That would silently break Part A's "resets every visit" guarantee
 * (answers surviving a reload in the same tab). Aliasing the leaves' `@/lib/safe-storage`
 * import to these no-ops means the demo holds ALL state in memory and truly resets on
 * refresh — and lib/safe-storage.ts is excluded from the sync whitelist entirely.
 *
 * Signatures mirror the real module exactly so the typed leaf imports resolve.
 */

type StorageKind = "local" | "session";

export function safeStorageGet(_kind: StorageKind, _key: string): string | null {
  return null;
}

export function safeStorageSet(_kind: StorageKind, _key: string, _value: string): void {
  /* no-op: the demo never persists — state lives in memory and resets on reload. */
}

export function safeStorageRemove(_kind: StorageKind, _key: string): void {
  /* no-op */
}
